// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3XNel","empty":"ModalGraph_empty__1bHDF"};